module.exports = __webpack_public_path__ + "static/22-thumb-a9ea65f093c355a77e1747d08bc7a002.jpg";